(function () {
  function initFaqTabs(root) {
    if (!root) return;

    if (root._aresFaqTabsAbort) {
      root._aresFaqTabsAbort.abort();
    }
    root._aresFaqTabsAbort = new AbortController();
    var signal = root._aresFaqTabsAbort.signal;

    var tabs = root.querySelectorAll('[data-tab-btn]');
    var panels = root.querySelectorAll('[data-tab-panel]');

    function setActive(key) {
      tabs.forEach(function (btn) {
        var on = btn.getAttribute('data-tab-btn') === key;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        var match = panel.getAttribute('data-tab-panel') === key;
        if (match) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', 'hidden');
        }
      });
    }

    var defaultKey = root.getAttribute('data-default-tab') || 'classes';
    setActive(defaultKey);

    tabs.forEach(function (btn) {
      btn.addEventListener(
        'click',
        function () {
          var key = btn.getAttribute('data-tab-btn');
          if (key) setActive(key);
        },
        { signal: signal }
      );
    });

    var detailsItems = root.querySelectorAll('details.ares-faq-tabs__item');
    detailsItems.forEach(function(detail) {
      detail.addEventListener('toggle', function() {
        if (detail.open) {
          detailsItems.forEach(function(otherDetail) {
            if (otherDetail !== detail && otherDetail.open) {
              otherDetail.removeAttribute('open');
            }
          });
        }
      }, { signal: signal });
    });
  }

  function scan(container) {
    (container || document).querySelectorAll('.js-ares-faq-tabs').forEach(initFaqTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && typeof event.target.querySelectorAll === 'function') {
      event.target.querySelectorAll('.js-ares-faq-tabs').forEach(initFaqTabs);
    }
  });
})();
